module.exports = __webpack_public_path__ + "static/reczebrattle-1420dcb2ce20bd5adbd1f8d64131170f.png";